import React from "react";
import { motion } from "framer-motion";

const FloatingImage = ({
    src,
    alt,
    className = "",
    delay = 0,
    aspectClass = "aspect-square",
}) => {
    if (!src) return null;

    return (
        <div className={`relative w-full ${aspectClass} ${className}`}>
            {/* Gold / purple glow halo */}
            <div
                className="absolute inset-0 dp-pulse rounded-[2rem]"
                style={{
                    background:
                        "radial-gradient(50% 40% at 50% 45%, rgba(212,175,55,0.22), transparent 70%), radial-gradient(40% 35% at 70% 70%, rgba(139,92,246,0.18), transparent 70%)",
                    filter: "blur(12px)",
                }}
            />

            <motion.div
                initial={{ opacity: 0, y: 20, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{
                    duration: 0.9,
                    delay,
                    ease: [0.22, 1, 0.36, 1],
                }}
                className="relative w-full h-full dp-float"
            >
                <div className="absolute inset-0 rounded-[2rem] dp-bloom-soft overflow-hidden bg-white/60 backdrop-blur-sm border border-white/40">
                    <img
                        src={src}
                        alt={alt}
                        className="w-full h-full object-contain p-4 md:p-6"
                        loading="eager"
                    />
                </div>
            </motion.div>
        </div>
    );
};

export default FloatingImage;
